package one.healthium.data.push

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.installations.installations
import dev.gitlive.firebase.messaging.messaging
import one.healthium.domain.push.PushTokenProvider

internal class FirebasePushTokenProvider : PushTokenProvider {
    override suspend fun getToken(): String = Firebase.messaging.getToken()
    override suspend fun getInstallationId(): String = Firebase.installations.getId()
}
